import { Logo } from "@/components/Logo";

const GOOGLE_AUTH = "https://auth.emergentagent.com/";

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex relative overflow-hidden bg-navy text-white flex-col justify-between p-12">
        <img src="/hero-poster.jpg" alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/60 to-navy/30" />
        <div className="relative"><Logo light testId="auth-logo" /></div>
        <div className="relative">
          <h2 className="font-heading text-5xl font-extrabold tracking-tighter leading-[0.95]">A new chapter.<br /><span className="text-[#9CCBD7]">A simpler road.</span></h2>
          <p className="text-white/75 mt-5 max-w-sm">Buy directly. Sell for one flat fee. Keep every pound of your sale.</p>
        </div>
        <p className="relative text-xs text-white/50">Vorra is a marketplace intermediary. Sellers are responsible for vehicle condition and accuracy.</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <div className="w-full max-w-sm">
          <div className="lg:hidden flex mb-8 justify-center"><Logo testId="auth-logo-mobile" /></div>
          <h1 className="font-heading text-3xl font-extrabold tracking-tight text-navy">{title}</h1>
          <p className="text-muted-foreground text-sm mt-1 mb-6">{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

export function googleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `${GOOGLE_AUTH}?redirect=${encodeURIComponent(redirectUrl)}`;
}
